import { NumberInput } from '@mantine/core';
import { useCreateRuleFormContext } from 'context/FormContext';
import { useAppContext } from 'context/hooks';
import { RuleParameters } from 'models/rules';
import { useTranslation } from 'react-i18next';
import {
  calculateWeightToMetric,
  displayWeight,
  getRuleParameterDefaults,
  getUserMeasurementSystem,
} from 'utils/helpers';
import { displayFormError } from 'utils/validation';

interface Props {
  dataField: string;
  fieldName: string;
}

export const PhysiologicalValueField = ({ fieldName, dataField }: Props) => {
  const { t } = useTranslation();
  const { getInputProps, values, setFieldValue, errors } = useCreateRuleFormContext();
  const { currentUser } = useAppContext();
  const unitSystem = getUserMeasurementSystem(currentUser);
  const defaultValue = getInputProps(`${dataField}.${fieldName}`).value;
  const parameter = getInputProps(`${dataField}.parameter`).value;
  const defaults = getRuleParameterDefaults(parameter, unitSystem);

  const isWeight = parameter === RuleParameters.weight;

  const handleChangeInput = (newValue: string | number) => {
    let valueToSave = Number(newValue);

    if (isWeight) {
      valueToSave = calculateWeightToMetric(valueToSave, unitSystem);
    }

    setFieldValue(`${dataField}.${fieldName}`, valueToSave > 0 ? valueToSave : undefined);
  };

  const visibleValue = isWeight ? displayWeight(defaultValue, unitSystem) : defaultValue;

  return (
    <NumberInput
      label={t(`${fieldName}_label`)}
      value={visibleValue || ''}
      onChange={handleChangeInput}
      placeholder={defaults && !errors[`${dataField}.${fieldName}`] ? `${defaults.defaultValue} ${defaults.unit}` : ''}
      allowNegative={false}
      allowDecimal={false}
      min={1}
      max={250}
      suffix={` ${defaults?.unit}`}
      styles={{ input: { width: 120 } }}
      disabled={!parameter || values.formDisabled}
      clampBehavior={'strict'}
      error={displayFormError({ errors, dataField: `${dataField}.${fieldName}` })}
    />
  );
};
